import type { FC } from "react";
import { Label } from "@root/shared/components/Label";

type Props = {
  typeName: string;
};

/**
 * スカウト残数の種別を表示するラベルコンポーネント
 * PC版・SP版共通で使用
 */
export const ScoutCountTypeLabel: FC<Props> = ({ typeName }) => {
  if (typeName === "契約プラン内") {
    return (
      <Label theme="lightPink" size="small">
        {typeName}
      </Label>
    );
  }

  if (typeName === "オプション購入") {
    return (
      <Label theme="lightGray" size="small">
        {typeName}
      </Label>
    );
  }

  // NOTE: 「その他」の場合や、RMから設定した動的な値が入る場合などがこの分岐に入る。
  return (
    <Label theme="gray" size="small" bold>
      {typeName}
    </Label>
  );
};
